import axios from '@/axios'
export const fetchBindWillIdentify = params =>
  axios.post('/amp/app/1.0/bindWillIdentify', params)
export const fetchWillIdentifyResult = params =>
  axios.post('/amp/app/1.0/getWillIdentifyResult', params)
